import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import PodLayout from "../components/PodLayout";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { useAuth } from "../contexts/AuthContext";
import { User, Lock, Sparkle, Calendar } from "@phosphor-icons/react";

export default function PodProfilePage() {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);

  useEffect(() => {
    api.get("/pod/me").then(r => setSub(r.data)).catch(() => setSub({}));
  }, []);

  const tier = sub?.plan || sub?.tier || (user?.pod_access ? "Member" : "—");
  const since = sub?.created_at || sub?.subscribed_at;
  const roundtable = sub?.roundtable || "Not joined";

  return (
    <PodLayout>
      <div className="p-6 md:p-8 max-w-3xl" data-testid="pod-profile-page">
        <p className="text-[10px] uppercase tracking-widest text-amber-600 font-bold">My Account</p>
        <h1 className="text-3xl font-bold text-slate-950" style={{ fontFamily: "'Outfit', sans-serif" }}>POD Profile</h1>

        <Card className="mt-6">
          <CardContent className="p-6">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-amber-400 text-slate-950 flex items-center justify-center text-2xl font-bold">
                {(user?.name || "?").slice(0, 1).toUpperCase()}
              </div>
              <div className="min-w-0">
                <p className="text-lg font-bold text-slate-950" data-testid="pod-profile-name">{user?.name || "—"}</p>
                <p className="text-sm text-slate-600 truncate" data-testid="pod-profile-email">{user?.email || "—"}</p>
                <p className="text-[11px] uppercase tracking-widest text-amber-600 font-bold mt-1">{user?.role || "pod_subscriber"}</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 pt-6 border-t border-slate-200">
              <div>
                <div className="flex items-center gap-1 text-xs uppercase tracking-widest text-slate-500 font-bold"><Sparkle size={12} /> Membership</div>
                <p className="text-sm text-slate-950 mt-1 font-semibold" data-testid="pod-profile-tier">{tier}</p>
              </div>
              <div>
                <div className="flex items-center gap-1 text-xs uppercase tracking-widest text-slate-500 font-bold"><User size={12} /> Roundtable</div>
                <p className="text-sm text-slate-950 mt-1 font-semibold" data-testid="pod-profile-roundtable">{roundtable}</p>
              </div>
              <div>
                <div className="flex items-center gap-1 text-xs uppercase tracking-widest text-slate-500 font-bold"><Calendar size={12} /> Member since</div>
                <p className="text-sm text-slate-950 mt-1 font-semibold">{since ? new Date(since).toLocaleDateString() : "—"}</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="mt-4">
          <CardContent className="p-6">
            <p className="text-sm font-bold text-slate-950">Security</p>
            <p className="text-xs text-slate-600 mt-1">Update your password to keep your POD account secure.</p>
            <Link to="/change-password" data-testid="pod-profile-change-password-link">
              <Button className="mt-3 bg-slate-950 hover:bg-slate-800 text-white">
                <Lock size={14} className="mr-2" /> Change Password
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </PodLayout>
  );
}
